<template>
  <div class="slip-detail">
    <div class="slip-detail__header">
      <div class="slip-detail__header-control">
        <div class="slip-detail__header-control-row slip-detail__header-control-row--product">
          <select ref="productSelect" class="slip-detail__product-select" placeholder="商品を検索して選択"></select>
          <span class="edit__submit-button--small" @click="addProductLine">商品を追加</span>
        </div>
        <div class="slip-detail__header-control-row">
          <span class="edit__submit-button--small" @click="addLine">通常行を追加</span>
          <span class="edit__submit-button--small" @click="addTextLine">テキスト行を追加</span>
        </div>
      </div>
    </div>

    <ul class="slip-detail__list">
      <li class="slip-detail__item--header">
        <div></div>
        <div>区分</div>
        <div>摘要</div>
        <div>数量</div>
        <div>単位</div>
        <div>単価</div>
        <div>税率</div>
        <div>明細金額</div>
        <div></div>
      </li>
      <li class="slip-detail__item" :class="{ 'slip-detail__item--text': !isNormal(slipDetail), 'slip-detail__item--error': hasError(slipDetail) }" :draggable="data.draggableIndex === index" @dragstart="dragStart(index)" @dragenter="dragEnter(index)" @dragend.stop.prevent="dragEnd" @dragover.stop.prevent="dragOver" v-bind:key="index" v-for="(slipDetail, index) in data.slipDetailList">
        <div class="slip-detail__item-icon--handle" @mousedown="enableDrag(index)" @mouseup="disableDrag">
          <i class="fa-solid fa-bars"></i>
        </div>
        <div class="edit__form-input">
          <select v-model.number="slipDetail.slip_detail_div" :class="{ 'is-invalid': slipDetail.errors.slip_detail_div }" :name="'slip_detail[' + index + '][slip_detail_div]'" @change="clearError(slipDetail, 'slip_detail_div')">
            <option :value="DIV_NORMAL">通常行</option>
            <option :value="DIV_TEXT">テキスト行</option>
          </select>
          <span v-if="slipDetail.errors.slip_detail_div" class="invalid-feedback">{{ slipDetail.errors.slip_detail_div }}</span>
        </div>
        <div class="edit__form-input">
          <input type="text" v-model="slipDetail.name" :class="{ 'is-invalid': slipDetail.errors.name }" :name="'slip_detail[' + index + '][name]'" @input="clearError(slipDetail, 'name')" />
          <input type="hidden" v-model="slipDetail.product_id" :name="'slip_detail[' + index + '][product_id]'" />
          <span v-if="slipDetail.errors.name" class="invalid-feedback">{{ slipDetail.errors.name }}</span>
        </div>
        <!-- テキスト行は摘要を横幅いっぱいに表示するため、数量以降のセルごと出力しない -->
        <template v-if="isNormal(slipDetail)">
          <div class="edit__form-input">
            <input type="number" step="0.01" class="slip-detail__input--right" :class="{ 'is-invalid': slipDetail.errors.quantity }" v-model="slipDetail.quantity" :name="'slip_detail[' + index + '][quantity]'" @input="clearError(slipDetail, 'quantity')" />
            <span v-if="slipDetail.errors.quantity" class="invalid-feedback">{{ slipDetail.errors.quantity }}</span>
          </div>
          <div class="edit__form-input">
            <input type="text" v-model="slipDetail.unit" :class="{ 'is-invalid': slipDetail.errors.unit }" :name="'slip_detail[' + index + '][unit]'" @input="clearError(slipDetail, 'unit')" />
            <span v-if="slipDetail.errors.unit" class="invalid-feedback">{{ slipDetail.errors.unit }}</span>
          </div>
          <div class="edit__form-input">
            <input type="number" class="slip-detail__input--right" :class="{ 'is-invalid': slipDetail.errors.unit_price }" v-model="slipDetail.unit_price" :name="'slip_detail[' + index + '][unit_price]'" @input="clearError(slipDetail, 'unit_price')" />
            <span v-if="slipDetail.errors.unit_price" class="invalid-feedback">{{ slipDetail.errors.unit_price }}</span>
          </div>
          <div class="edit__form-input">
            <select v-model.number="slipDetail.tax_rate" :class="{ 'is-invalid': slipDetail.errors.tax_rate }" :name="'slip_detail[' + index + '][tax_rate]'" @change="clearError(slipDetail, 'tax_rate')">
              <option v-bind:key="taxRate" v-for="taxRate in TAX_RATE_LIST" :value="taxRate">{{ taxRate }}%</option>
            </select>
            <span v-if="slipDetail.errors.tax_rate" class="invalid-feedback">{{ slipDetail.errors.tax_rate }}</span>
          </div>
          <div class="slip-detail__amount">{{ formatNumber(amount(slipDetail)) }}</div>
        </template>
        <div class="slip-detail__item-icon">
          <i class="fa-solid fa-times" @click="deleteLine(index)"></i>
        </div>
      </li>
    </ul>

    <div class="slip__total">
      <table class="slip__total-table">
        <tbody>
          <tr>
            <th>小計</th>
            <td>{{ formatNumber(calculated.subtotal) }}円</td>
          </tr>
          <tr>
            <th>消費税</th>
            <td>{{ formatNumber(calculated.tax) }}円</td>
          </tr>
          <tr class="slip__total-table-row--total">
            <th>合計</th>
            <td>{{ formatNumber(calculated.total) }}円</td>
          </tr>
          <template v-bind:key="taxDetail.tax_rate" v-for="(taxDetail, index) in calculated.taxDetailList">
            <tr class="slip__total-table-row--sub">
              <th>{{ index === 0 ? '内訳' : '' }} {{ taxDetail.tax_rate }}%対象(税抜)</th>
              <td>{{ formatNumber(taxDetail.target_amount) }}円</td>
            </tr>
            <tr class="slip__total-table-row--sub">
              <th>{{ taxDetail.tax_rate }}%消費税</th>
              <td>{{ formatNumber(taxDetail.tax) }}円</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="scss">
.slip-detail {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 10px;
  }
  &__title {
    margin: 0;
  }
  //商品追加 / 行追加 をそれぞれ1行にまとめる
  //(商品セレクトの%指定を解決させるため、残り幅いっぱいの確定幅を持たせる)
  &__header-control {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  &__header-control-row {
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 5px;

    //.edit__submit-button--small は margin-left:auto を持っており、
    //そのままだとflex内でボタン同士が左右に押し広げられるため打ち消す
    > .edit__submit-button--small {
      flex: 0 0 auto;
      margin-left: 0;
      margin-top: 0;
    }

    //商品セレクトの行は折り返さず、ボタン以外の残り幅をすべてセレクトに割り当てる
    &--product {
      flex-wrap: nowrap;
    }
  }
  //TomSelectは選択中の商品名が長いと横に伸びてボタンが折り返されるため、
  //幅は伸縮させたうえで選択中の商品名を省略表示(...)にする
  //TomSelect未初期化時(素のselect)のフォールバック
  &__product-select {
    flex: 1 1 auto;
    min-width: 0;
  }

  //TomSelect初期化後のラッパー。
  //選択中の商品名は white-space:nowrap のため、幅を内容任せにすると
  //min-contentが親(#FormPanel → .main)まで伝播して画面全体が横に広がる。
  //width:0 で内容基準の幅を断ち切り、flex-growで行の残り幅いっぱいまで広げる。
  .ts-wrapper.slip-detail__product-select {
    flex: 1 1 0;
    width: 0;
    min-width: 0;

    .ts-control {
      min-width: 0;
      flex-wrap: nowrap;
      overflow: hidden;

      > .item {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      > input {
        min-width: 0;
      }
    }
  }
  &__list {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  &__item {
    //摘要(1fr)に幅を割り当てるため、それ以外の列は必要最小限の固定幅にする
    @mixin base() {
      width: 100%;
      display: grid;
      grid-template-columns: 20px 76px 1fr 66px 52px 84px 58px 92px 20px;
      gap: 6px;
      align-items: center;
      font-size: 0.8rem;
    }
    @include base;

    &--header {
      @include base;
      font-weight: bold;
    }

    //テキスト行は摘要を横幅いっぱいに表示する
    &--text {
      grid-template-columns: 20px 76px 1fr 20px;
    }

    //エラー文言で行が高くなるため、入力欄の上端を揃える。
    //明細金額・アイコンは入力欄と同じ高さの箱に入れて、文字位置を入力欄と揃える
    &--error {
      align-items: start;

      .slip-detail__amount,
      .slip-detail__item-icon,
      .slip-detail__item-icon--handle {
        height: 30px;
      }

      .slip-detail__amount {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    //エラー文言は列幅が狭いため小さめに表示する
    .invalid-feedback {
      font-size: 0.7rem;
      line-height: 1.3;
      padding-top: 1px;
    }

    //明細行は行数が多くなるため入力欄を小さめにする
    //(.edit__form-input input[type="text"] より詳細度を高くする)
    .edit__form-input {
      input[type='text'],
      input[type='number'],
      select {
        width: 100%;
        height: 30px;
        padding: 4px 6px;
        font-size: 0.8rem;
        border: solid 1px #ccc;
        border-radius: 5px;
        background-color: #fafafa;
        box-shadow: inset 0 0 5px #f3f3f3;
      }

      select {
        max-width: 100%;
        padding-right: 20px;
        background-position: right 0.4rem center;
      }
    }
  }
  &__item-icon {
    @mixin icon-base() {
      font-size: 16px;
      height: 35px;
      display: flex;
      align-items: center;
      color: #444;
      cursor: pointer;
    }
    @include icon-base;

    //並べ替えハンドル(ここを掴んだ時だけ行がドラッグ可能になる)
    &--handle {
      @include icon-base;
      cursor: move;
    }
  }
  &__input--right {
    text-align: right;
  }
  &__amount {
    text-align: right;
    padding-right: 5px;
    font-size: 0.8rem;
  }
}
</style>

<script setup>
import { reactive, computed, onMounted, onBeforeUnmount, ref } from 'vue';
import TomSelect from 'tom-select';

//帳票明細区分 (App\Enums\SlipDetailDiv と対応)
const DIV_NORMAL = 1;
const DIV_TEXT = 2;
const TAX_RATE_LIST = [10, 8];
//単位の既定値
const DEFAULT_UNIT = '個';
//摘要に商品コードを付ける際の区切り文字
const PRODUCT_NAME_SEPARATOR = ' ';

const productSelect = ref(null);

const data = reactive({
  slipDetailList: [],
  draggingIndex: null,
  //並べ替え対象の行(ハンドルを押している間だけ設定される)
  draggableIndex: null,
});

onMounted(() => {
  const slipDetailListJson = document.getElementById('SlipDetailListJson');

  if (slipDetailListJson && slipDetailListJson.value !== '') {
    data.slipDetailList = JSON.parse(slipDetailListJson.value).map((slipDetail) => {
      return {
        slip_detail_div: Number(slipDetail.slip_detail_div) || DIV_NORMAL,
        product_id: slipDetail.product_id ?? '',
        name: slipDetail.name ?? '',
        quantity: slipDetail.quantity ?? '',
        unit: slipDetail.unit ?? '',
        unit_price: slipDetail.unit_price ?? '',
        tax_rate: Number(slipDetail.tax_rate) || 10,
        //サーバーから渡された行ごとのバリデーションエラー
        errors: slipDetail.errors ?? {},
      };
    });
  }

  if (data.slipDetailList.length === 0) {
    data.slipDetailList = [createLine(DIV_NORMAL)];
  }

  //ハンドル外でマウスを離した場合にも並べ替え可能状態を解除する
  document.addEventListener('mouseup', disableDrag);

  //商品ドロップダウン
  new TomSelect(productSelect.value, {
    valueField: 'id',
    labelField: 'label',
    searchField: 'label',
    load: function (query, callback) {
      fetch('/slips/search_product?q=' + encodeURIComponent(query))
        .then((response) => response.json())
        .then((json) => callback(json))
        .catch(() => callback());
    },
    create: false,
    maxOptions: 50,
  });
});

onBeforeUnmount(() => {
  document.removeEventListener('mouseup', disableDrag);
});

const createLine = function (slipDetailDiv) {
  return {
    slip_detail_div: slipDetailDiv,
    product_id: '',
    name: '',
    quantity: slipDetailDiv === DIV_NORMAL ? 1 : '',
    unit: slipDetailDiv === DIV_NORMAL ? DEFAULT_UNIT : '',
    unit_price: slipDetailDiv === DIV_NORMAL ? 0 : '',
    tax_rate: 10,
    errors: {},
  };
};

//入力し直した項目のエラー表示は消す
const clearError = function (slipDetail, column) {
  if (slipDetail.errors[column]) delete slipDetail.errors[column];
};

//行にバリデーションエラーが残っているか
const hasError = function (slipDetail) {
  return Object.keys(slipDetail.errors ?? {}).length > 0;
};

const isNormal = function (slipDetail) {
  return Number(slipDetail.slip_detail_div) === DIV_NORMAL;
};

const amount = function (slipDetail) {
  if (!isNormal(slipDetail)) return 0;

  return Math.round((Number(slipDetail.quantity) || 0) * (Number(slipDetail.unit_price) || 0));
};

const calculated = computed(() => {
  let subtotal = 0;
  const taxTargetDic = {};

  data.slipDetailList.forEach((slipDetail) => {
    if (!isNormal(slipDetail)) return;

    const detailAmount = amount(slipDetail);
    const taxRate = Number(slipDetail.tax_rate) || 0;

    subtotal += detailAmount;
    taxTargetDic[taxRate] = (taxTargetDic[taxRate] ?? 0) + detailAmount;
  });

  let tax = 0;
  const taxDetailList = Object.keys(taxTargetDic)
    .map((taxRate) => Number(taxRate))
    .sort((a, b) => b - a)
    .map((taxRate) => {
      const targetAmount = taxTargetDic[taxRate];
      const taxAmount = Math.floor((targetAmount * taxRate) / 100);
      tax += taxAmount;

      return { tax_rate: taxRate, target_amount: targetAmount, tax: taxAmount };
    });

  return { subtotal, tax, total: subtotal + tax, taxDetailList };
});

const formatNumber = function (value) {
  return Number(value ?? 0).toLocaleString();
};

const addLine = async function () {
  data.slipDetailList.push(createLine(DIV_NORMAL));
};

const addTextLine = async function () {
  data.slipDetailList.push(createLine(DIV_TEXT));
};

//摘要に入れる文字列(商品コード + 商品名)を組み立てる
const buildProductName = function (product) {
  return [product.code, product.name].filter((value) => value).join(PRODUCT_NAME_SEPARATOR);
};

const addProductLine = async function () {
  const tomSelect = productSelect.value.tomselect;
  const productID = tomSelect.getValue();

  if (!productID) return;

  const product = tomSelect.options[productID];

  if (!product) return;

  data.slipDetailList.push({
    slip_detail_div: DIV_NORMAL,
    product_id: product.id,
    name: buildProductName(product),
    quantity: 1,
    unit: DEFAULT_UNIT,
    unit_price: product.price ?? 0,
    tax_rate: 10,
    errors: {},
  });

  tomSelect.clear();
};

const deleteLine = async function (index) {
  data.slipDetailList = data.slipDetailList.filter((slipDetail, i) => i !== index);
};

//ハンドル以外(テキストボックス等)のドラッグで並べ替えが始まらないよう、
//ハンドルを押している間だけ行をドラッグ可能にする
const enableDrag = function (index) {
  data.draggableIndex = index;
};

const disableDrag = function () {
  data.draggableIndex = null;
};

const dragStart = async function (index) {
  data.draggingIndex = index;
};

const dragEnter = async function (index) {
  if (index === data.draggingIndex) return;

  const deleteElement = data.slipDetailList.splice(data.draggingIndex, 1)[0];
  data.slipDetailList.splice(index, 0, deleteElement);
  data.draggingIndex = index;
};

const dragOver = async function () {};

const dragEnd = async function () {
  data.draggingIndex = null;
  data.draggableIndex = null;
};
</script>
